// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2T3WT","colBig":"styles_colBig__9pMnm","colSmall":"styles_colSmall__lhOxu","shopifyNameWrapper":"styles_shopifyNameWrapper__3_RJ9"};